module.exports = __webpack_public_path__ + "static/media/vu.e96192d9.svg";